import i18n from "@shared/locale/i18n.js";

// Helper to get current locale translations
function getMessages() {
  const locale = i18n.global.locale.value || i18n.global.locale;
  return (
    i18n.global.messages.value?.[locale] || i18n.global.messages[locale] || {}
  );
}

export default class ModelBase {
  constructor({ i18nModelName, columns, editColumns }, attributes) {
    columns.forEach((key) => {
      this[key] = attributes[key];
    });

    this.i18nModelName = i18nModelName;
    this.editColumns = editColumns;
  }

  isNewRecord() {
    return !this.id;
  }

  isDataLoaded() {
    return !!this.id;
  }

  // for i18n
  static modelNameLocaleText() {
    const instance = new this();

    if (!instance.i18nModelName) return console.error("no i18nModelName");

    return instance.modelNameLocaleText();
  }

  static attributeLocaleText(key, value) {
    const instance = new this();

    if (!instance.i18nModelName) return console.error("no i18nModelName");

    const messages = getMessages();
    let result = messages.activerecord?.attributes;

    if (!result) return undefined;
    [instance.i18nModelName, key, value].filter(Boolean).forEach((k) => {
      if (result && k in result) {
        result = result[k];
      } else {
        result = undefined;
      }
    });

    if (result === undefined) {
      const path = [instance.i18nModelName, key, value]
        .filter(Boolean)
        .join(".");
      console.warn(`[i18n] missing: activerecord.attributes.${path}`);
      return `⚠ ${key}`;
    }

    return result;
  }

  static enumLocaleText(key, value) {
    const instance = new this();

    if (!instance.i18nModelName) return console.error("no i18nModelName");

    const messages = getMessages();
    return messages.enums?.[instance.i18nModelName]?.[key]?.[value];
  }

  static enumLocaleList(key) {
    const instance = new this();

    if (!instance.i18nModelName) return console.error("no i18nModelName");

    const messages = getMessages();
    return messages.enums?.[instance.i18nModelName]?.[key];
  }

  static aasmStateLocaleText(key, value) {
    const instance = new this();

    if (!instance.i18nModelName) return console.error("no i18nModelName");

    const messages = getMessages();
    return messages.aasm_state?.[instance.i18nModelName]?.[key]?.[value];
  }

  static aasmStateLocaleList(key) {
    const instance = new this();

    if (!instance.i18nModelName) return console.error("no i18nModelName");

    const messages = getMessages();
    return messages.aasm_state?.[instance.i18nModelName]?.[key];
  }

  modelNameLocaleText() {
    if (!this.i18nModelName) return console.error("no i18nModelName");

    const messages = getMessages();
    return messages.activerecord?.models?.[this.i18nModelName];
  }

  attributeLocaleText(...attribute) {
    if (!this.i18nModelName) return console.error("no i18nModelName");

    const messages = getMessages();
    let result = messages.activerecord?.attributes;

    if (!result) return undefined;
    [this.i18nModelName, ...attribute.filter(Boolean)].forEach((key) => {
      if (result && key in result) {
        result = result[key];
      } else {
        result = undefined;
      }
    });

    return result;
  }

  enumLocaleText(key) {
    if (!this.i18nModelName) return console.error("no i18nModelName");

    const messages = getMessages();
    return messages.enums?.[this.i18nModelName]?.[key]?.[this[key]];
  }

  aasmStateLocaleText(key) {
    if (!this.i18nModelName) return console.error("no i18nModelName");

    const messages = getMessages();
    return messages.aasm_state?.[this.i18nModelName]?.[key]?.[this[key]];
  }
}
